import VirtualizedVehicleList from '@/components/ui/vehicle-list/virtualized-vehicle-list';
import { useVehiclesContext } from '@/contexts/vehicles-provider';
import { createFileRoute } from '@tanstack/react-router';
import { observer } from 'mobx-react-lite';

const AllPage = observer(() => {
  const { allVehicles, searchFilterCallback } = useVehiclesContext();
  return (
    <div>
      <VirtualizedVehicleList
        vehicleListingsData={allVehicles}
        filterCallback={() => true}
        findInViewFilterCallback={searchFilterCallback}
        enableScope={() => {}}
      />
    </div>
  );
});

export const Route = createFileRoute('/(authenticated)/cars/all/')({
  component: AllPage,
});
